/* eslint-disable no-debugger */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IImageData } from '@msdyn365-commerce/core';
import { ILobasCategoryImageData } from './lobas-category-image.data';
import { ILobasCategoryImageProps } from './lobas-category-image.props.autogenerated';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';

export interface ILobasCategoryImageViewProps extends ILobasCategoryImageProps<ILobasCategoryImageData> {
    image?: IImageData;
}

/**
 *
 * LobasCategoryImage component
 * @extends {React.PureComponent<ILobasCategoryImageProps<ILobasCategoryImageData>>}
 */
class LobasCategoryImage extends React.PureComponent<ILobasCategoryImageProps<ILobasCategoryImageData>> {
    public render(): JSX.Element {
        const data = this.props.data;

        let viewProps: ILobasCategoryImageViewProps = {
            ...(this.props as ILobasCategoryImageProps<ILobasCategoryImageData>)
        };

        if (
            data &&
            data.category &&
            data.category.result &&
            ArrayExtensions.hasElements(data.category.result.Images) &&
            data.category.result.Images[0].Uri
        ) {
            viewProps = {
                ...viewProps,
                image: {
                    src: data.category.result.Images[0].Uri,
                    imageSettings: this.props.config.categoryImageSettings
                } as IImageData
            };
        }

        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default LobasCategoryImage;
